import { TERRAFORM_ENV_ID } from "../scenarios/edu-scenarios";

export const SecurityGroupTerraformArray = [
  {
    Name: "ElS-ProteinResearch-SecurityGroup",
    OwnerId: "568753834354",
    VpcId: "vpc-1594696f",
    AccountNumber: "904433914959",
    UpdatedAt: null,
    Description:
      "ElS-ProteinResearch-SecurityGroup created 2023-07-07T08:36:12.468+05:30",
    Tags: [
      {
        Key: "Service",
        Value: "Protein Research",
      },
    ],
    ResourceId: "sg-0008bef9e622b9c17",
    RegionCode: "us-east-1",
    OrganizationId: "e514d2d2-dcb8-4daf-9a7d-93feb7eedf3c",
    DepartmentId: "98ea91b7-551f-4d35-a113-b37fcd840a71",
    Departments: ["98ea91b7-551f-4d35-a113-b37fcd840a71"],
    EnvironmentId: TERRAFORM_ENV_ID,
    ApplicationId: TERRAFORM_ENV_ID,
    Apps: [TERRAFORM_ENV_ID],
    ResourceName: "ElS-ProteinResearch-SecurityGroup",
  },
];

export const routeTableTerraformArray = [
  {
    ARN: "arn:aws:ec2:us-east-1:904433914959:route-table/rtb-0df1997408463gf34",
    AccountNumber: "904433914959",
    Apps: [TERRAFORM_ENV_ID],
    Departments: ["98ea91b7-551f-4d35-a113-b37fcd840a71"],
    ID: "05610d3e-81c8-4a18-9436-d47cff412f3b",
    OrganizationId: "e514d2d2-dcb8-4daf-9a7d-93feb7eedf3c",
    OwnerId: "568753834354",
    PropagatingVgws: [],
    RegionCode: "us-east-1",
    ResourceId: "rtb-0df1997408463gf34",
    ResourceName: "ElS-ProteinResearch-RouteTable",
    ResourceType: "RouteTable",
    RouteTableId: "rtb-0df1997408463gf34",
    Routes: [
      {
        DestinationCidrBlock: "172.31.0.0/16",
        GatewayId: "local",
        Origin: "CreateRouteTable",
        State: "active",
      },
      {
        DestinationPrefixListId: "pl-63a5400a",
        GatewayId: "vpce-06b7b2ec070384258",
        Origin: "CreateRoute",
        State: "active",
      },
    ],
    Tags: [
      {
        Key: "Name",
        Value: "ElS-ProteinResearch-RouteTable",
      },
    ],
    VpcId: "vpc-1594696f",
  },
];

export const VolumeTerraformArray = [
  {
    AccountNumber: "904433914959",
    InstanceId: "i-8923h0f92832",
    Tags: [],
    VolumeType: "gp2",
    RegionCode: "us-east-1",
    State: "in-use",
    VolumeSize: 4,
    UpdatedAt: "2023-07-07T09:04:34Z",
    ResourceId: "vol-0008bef9e622b9c17",
    IsDeleted: 0,
    ResourceName: "vol-0b233a3300ee5505b",
    VolumeName: "vol-0b233a3300ee5505b",
    AvailabilityZone: "us-east-1d",
    OrganizationId: "e514d2d2-dcb8-4daf-9a7d-93feb7eedf3c",
    DepartmentId: "98ea91b7-551f-4d35-a113-b37fcd840a71",
    Departments: ["98ea91b7-551f-4d35-a113-b37fcd840a71"],
    EnvironmentId: TERRAFORM_ENV_ID,
    ApplicationId: TERRAFORM_ENV_ID,
    Apps: [TERRAFORM_ENV_ID],
  },
  {
    AccountNumber: "904433914959",
    InstanceId: "i-8923h0f92832",
    Tags: [],
    VolumeType: "gp2",
    RegionCode: "us-east-1",
    State: "in-use",
    VolumeSize: 4,
    UpdatedAt: "2023-07-07T09:04:34Z",
    ResourceId: "vol-0b233a3300ee5505b",
    IsDeleted: 0,
    ResourceName: "vol-0b233a3300ee5505b",
    VolumeName: "vol-0b233a3300ee5505b",
    AvailabilityZone: "us-east-1d",
    OrganizationId: "e514d2d2-dcb8-4daf-9a7d-93feb7eedf3c",
    DepartmentId: "98ea91b7-551f-4d35-a113-b37fcd840a71",
    Departments: ["98ea91b7-551f-4d35-a113-b37fcd840a71"],
    EnvironmentId: TERRAFORM_ENV_ID,
    ApplicationId: TERRAFORM_ENV_ID,
    Apps: [TERRAFORM_ENV_ID],
  },
  {
    AccountNumber: "904433914959",
    InstanceId: "i-8923h0f92832",
    Tags: [],
    VolumeType: "gp2",
    RegionCode: "us-east-1",
    State: "in-use",
    VolumeSize: 128,
    UpdatedAt: "2023-07-07T09:04:34Z",
    ResourceId: "vol-0b6be152de65e4fe6",
    IsDeleted: 0,
    ResourceName: "vol-0b6be152de65e4fe6",
    VolumeName: "vol-0b6be152de65e4fe6",
    AvailabilityZone: "us-east-1d",
    OrganizationId: "e514d2d2-dcb8-4daf-9a7d-93feb7eedf3c",
    DepartmentId: "98ea91b7-551f-4d35-a113-b37fcd840a71",
    Departments: ["98ea91b7-551f-4d35-a113-b37fcd840a71"],
    EnvironmentId: TERRAFORM_ENV_ID,
    ApplicationId: TERRAFORM_ENV_ID,
    Apps: [TERRAFORM_ENV_ID],
  },
  {
    AccountNumber: "904433914959",
    InstanceId: "i-8923h0f92832",
    Tags: [],
    VolumeType: "gp2",
    RegionCode: "us-east-1",
    State: "in-use",
    VolumeSize: 1024,
    UpdatedAt: "2023-07-07T09:04:34Z",
    ResourceId: "vol-01ce71c498ea3519d",
    IsDeleted: 0,
    ResourceName: "vol-01ce71c498ea3519d",
    VolumeName: "vol-01ce71c498ea3519d",
    AvailabilityZone: "us-east-1d",
    OrganizationId: "e514d2d2-dcb8-4daf-9a7d-93feb7eedf3c",
    DepartmentId: "98ea91b7-551f-4d35-a113-b37fcd840a71",
    Departments: ["98ea91b7-551f-4d35-a113-b37fcd840a71"],
    EnvironmentId: TERRAFORM_ENV_ID,
    ApplicationId: TERRAFORM_ENV_ID,
    Apps: [TERRAFORM_ENV_ID],
  },
  {
    AccountNumber: "904433914959",
    InstanceId: "i-8923h0f92832",
    Tags: [],
    VolumeType: "gp2",
    RegionCode: "us-east-1",
    State: "in-use",
    VolumeSize: 256,
    UpdatedAt: "2023-07-07T09:04:34Z",
    ResourceId: "vol-025b52cd595af2934",
    IsDeleted: 0,
    ResourceName: "vol-025b52cd595af2934",
    VolumeName: "vol-025b52cd595af2934",
    AvailabilityZone: "us-east-1d",
    OrganizationId: "e514d2d2-dcb8-4daf-9a7d-93feb7eedf3c",
    DepartmentId: "98ea91b7-551f-4d35-a113-b37fcd840a71",
    Departments: ["98ea91b7-551f-4d35-a113-b37fcd840a71"],
    EnvironmentId: TERRAFORM_ENV_ID,
    ApplicationId: TERRAFORM_ENV_ID,
    Apps: [TERRAFORM_ENV_ID],
  },
  {
    AccountNumber: "904433914959",
    InstanceId: "i-97427910de121",
    Tags: [],
    VolumeType: "gp2",
    RegionCode: "us-east-1",
    State: "in-use",
    VolumeSize: 256,
    UpdatedAt: "2023-07-07T09:04:34Z",
    ResourceId: "vol-871298ui012312",
    IsDeleted: 0,
    ResourceName: "vol-871298ui012312",
    VolumeName: "vol-871298ui012312",
    AvailabilityZone: "us-east-1d",
    OrganizationId: "e514d2d2-dcb8-4daf-9a7d-93feb7eedf3c",
    DepartmentId: "98ea91b7-551f-4d35-a113-b37fcd840a71",
    Departments: ["98ea91b7-551f-4d35-a113-b37fcd840a71"],
    EnvironmentId: TERRAFORM_ENV_ID,
    ApplicationId: TERRAFORM_ENV_ID,
    Apps: [TERRAFORM_ENV_ID],
  },
  {
    AccountNumber: "904433914959",
    InstanceId: "i-97427910de121",
    Tags: [],
    VolumeType: "gp2",
    RegionCode: "us-east-1",
    State: "in-use",
    VolumeSize: 1024,
    UpdatedAt: "2023-07-07T09:04:34Z",
    ResourceId: "vol-897123dew21da1",
    IsDeleted: 0,
    ResourceName: "vol-897123dew21da1",
    VolumeName: "vol-897123dew21da1",
    AvailabilityZone: "us-east-1d",
    OrganizationId: "e514d2d2-dcb8-4daf-9a7d-93feb7eedf3c",
    DepartmentId: "98ea91b7-551f-4d35-a113-b37fcd840a71",
    Departments: ["98ea91b7-551f-4d35-a113-b37fcd840a71"],
    EnvironmentId: TERRAFORM_ENV_ID,
    ApplicationId: TERRAFORM_ENV_ID,
    Apps: [TERRAFORM_ENV_ID],
  },
  {
    AccountNumber: "904433914959",
    InstanceId: "i-97427910de121",
    Tags: [],
    VolumeType: "gp2",
    RegionCode: "us-east-1",
    State: "in-use",
    VolumeSize: 512,
    UpdatedAt: "2023-07-07T09:04:34Z",
    ResourceId: "vol-7763209123hd12",
    IsDeleted: 0,
    ResourceName: "vol-7763209123hd12",
    VolumeName: "vol-7763209123hd12",
    AvailabilityZone: "us-east-1d",
    OrganizationId: "e514d2d2-dcb8-4daf-9a7d-93feb7eedf3c",
    DepartmentId: "98ea91b7-551f-4d35-a113-b37fcd840a71",
    Departments: ["98ea91b7-551f-4d35-a113-b37fcd840a71"],
    EnvironmentId: TERRAFORM_ENV_ID,
    ApplicationId: TERRAFORM_ENV_ID,
    Apps: [TERRAFORM_ENV_ID],
  },
];

export const RdsTerraformArray = [
  {
    AccountNumber: "904433914959",
    ARN: "arn:aws:rds:us-east-1:904433914959:db:proteinresearch-datafeeder-db",
    UpdatedAt: "2023-07-07T09:04:34Z",
    ResourceId: "rds-012bu10932e13",
    IsDeleted: 0,
    ResourceName: "proteinresearch-datafeeder-db",
    RegionCode: "us-east-1",
    RegionName: "Virginia",
    OrganizationId: "e514d2d2-dcb8-4daf-9a7d-93feb7eedf3c",
    DepartmentId: "98ea91b7-551f-4d35-a113-b37fcd840a71",
    Departments: ["98ea91b7-551f-4d35-a113-b37fcd840a71"],
    EnvironmentId: TERRAFORM_ENV_ID,
    ApplicationId: TERRAFORM_ENV_ID,
    Apps: [TERRAFORM_ENV_ID],
  },
  {
    AccountNumber: "904433914959",
    ARN: "arn:aws:rds:us-east-1:904433914959:db:proteinresearch-datafetcher-db",
    UpdatedAt: "2023-07-07T09:04:34Z",
    ResourceId: "rds-0008bef9e622b9c17",
    IsDeleted: 0,
    ResourceName: "proteinresearch-datafetcher-db",
    RegionCode: "us-east-1",
    RegionName: "Virginia",
    OrganizationId: "e514d2d2-dcb8-4daf-9a7d-93feb7eedf3c",
    DepartmentId: "98ea91b7-551f-4d35-a113-b37fcd840a71",
    Departments: ["98ea91b7-551f-4d35-a113-b37fcd840a71"],
    EnvironmentId: TERRAFORM_ENV_ID,
    ApplicationId: TERRAFORM_ENV_ID,
    Apps: [TERRAFORM_ENV_ID],
  },
  {
    AccountNumber: "904433914959",
    ARN: "arn:aws:rds:us-east-1:904433914959:db:proteinresearch-store-db",
    UpdatedAt: "2023-07-07T09:04:34Z",
    ResourceId: "rds-01437bw9023e89754",
    IsDeleted: 0,
    ResourceName: "proteinresearch-store-db",
    RegionCode: "us-east-1",
    RegionName: "Virginia",
    OrganizationId: "e514d2d2-dcb8-4daf-9a7d-93feb7eedf3c",
    DepartmentId: "98ea91b7-551f-4d35-a113-b37fcd840a71",
    Departments: ["98ea91b7-551f-4d35-a113-b37fcd840a71"],
    EnvironmentId: TERRAFORM_ENV_ID,
    ApplicationId: TERRAFORM_ENV_ID,
    Apps: [TERRAFORM_ENV_ID],
  },
];
